import { Box, Typography } from '@mui/material';
import React from 'react';

const NotFound = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Typography
                variant="h2"
                noWrap
                sx={{
                    mr: 2,
                    display: { xs: "none", md: "flex" },
                    fontFamily: "monospace",
                    fontWeight: 700,
                    letterSpacing: ".3rem",
                    color: "inherit",
                }}
            >
                Not Found
            </Typography>
        </Box>
    )
}

export default NotFound
